/**
 * This file should only contains global utilities functions
 *
 * All functions could be accessed with Utilities.<FN> (see Webpack config)
 */
import { modalBus } from './Modal/javascript/modalBus';
import StepsManager from './Modal/javascript/StepsManager';
import { createNoticeInstance } from './Notices/javascript/notices-utils';

export function showNoticeByName(noticeName) {
  $('[data-notice-name="' + noticeName + '"]').trigger('showNotice');
}

export function showNoticeWithoutDispatcher(opts) {
  var noty = createNoticeInstance(null, opts);
  noty.show();

  return noty;
}

export function showModalByDataAction(modalName, onShow) {
  // Make async execution bootbox modal creation and listener
  setTimeout(function() {
    modalBus.trigger('callModal', modalName);
    if (typeof onShow === 'function') {
      $(document).on('show.bs.modal', onShow);
    }
  }, 0);
}

export function createStepManager(steps, animationTime) {
  return new StepsManager(steps, animationTime);
}

export function EventCallbacksPair(eventType, callback) {
  this.eventType = eventType;
  this.callbacks = [callback];
}
